import React, { useState, useEffect, useContext } from 'react';
import { useParams, useLocation } from 'react-router-dom'; // Import useLocation
import Header from '../components/Header';
import Layout from '../components/Layout';
import Binder from '../components/Binder'; // Import the Binder component
// import EnergySymbols from '../components/EnergySymbols'; // Remove EnergySymbols import
import './ListingsPage.css';
import '../styles/shared.css';
import { LoadingContext } from '../App';

const ListingsPage = ({ supertype, isPromo }) => {
    const { name, searchTerm } = useParams(); // Add searchTerm to params
    const location = useLocation();
    const [listings, setListings] = useState([]);
    const [error, setError] = useState(null);
    const [type, setType] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const { setLoading } = useContext(LoadingContext);

    useEffect(() => {
        const fetchListings = async () => {
            setLoading(true);
            try {
                let url = `${apiBaseUrl}/listings`;
                const params = new URLSearchParams();

                if (supertype) {
                    params.append('supertype', supertype);
                }
                if (searchTerm) {
                    params.append('cardName', searchTerm);
                }
                params.append('count', '500');

                const response = await fetch(`${url}?${params.toString()}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch listings');
                }
                const data = await response.json();
                if (data.status === 'success' && Array.isArray(data.listings)) {
                    setListings(data.listings);
                } else {
                    setListings([]);
                }
            } catch (err) {
                console.error('Error fetching listings:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchListings();
    }, [searchTerm, type, supertype, name, isPromo]); // Add searchTerm as a dependency

    if (error) return <p>Error loading listings: {error}</p>;

    return (
        <Layout>
            <div className={`listings-page ${supertype !== 'pokemon' && type !== 'pokemon' ? 'listings-page-no-energy' : ''}`}>
                <Header setSupertype={setType} setType={setType} resetListings={() => {}} />
                <Binder listings={listings} />
            </div>
        </Layout>
    );
};

export default ListingsPage;
